const ar = {
  translation: {
    brand: 'CrebtoPay',
    nav: {
      home: 'الرئيسية',
      dashboard: 'شراء العملات الرقمية',
      wallet: 'المحفظة',
      transactions: 'سجل الشراء',
      aiChat: 'المساعد الذكي',
      admin: 'لوحة المسؤول',
      search: 'بحث',
      searchCrypto: 'بحث عن عملة',
      menu: 'القائمة',
      menuSubtitle: 'تنقّل بسرعة بين الصفحات',
      profile: 'الملف الشخصي',
    },
    auth: {
      signIn: 'تسجيل الدخول',
      signUp: 'إنشاء حساب',
      signOut: 'تسجيل الخروج',
      email: 'البريد الإلكتروني (Gmail)',
      password: 'كلمة المرور',
      confirmPassword: 'تأكيد كلمة المرور',
      fullName: 'الاسم الكامل',
      namePlaceholder: 'أحمد محمد',
      processing: 'جاري المعالجة...',
      welcomeBack: 'مرحباً بعودتك!',
      createAccount: 'أنشئ حسابك وابدأ التداول',
      haveAccount: 'لديك حساب؟ تسجيل الدخول',
      noAccount: 'ليس لديك حساب؟ إنشاء حساب',
      accountCreated: 'تم إنشاء الحساب بنجاح!',
      welcomeToPlatform: 'مرحباً بك في CrebtoPay',
      alreadyRegistered: 'البريد مسجل مسبقاً',
      alreadyRegisteredDesc: 'هذا البريد الإلكتروني مسجل بالفعل. جرب تسجيل الدخول.',
      invalidCredentials: 'بيانات غير صحيحة',
      invalidCredentialsDesc: 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
      emailNotConfirmed: 'البريد غير مؤكد',
      emailNotConfirmedDesc: 'يرجى تأكيد بريدك الإلكتروني أولاً.',
      error: 'حدث خطأ',
      errorDesc: 'حدث خطأ غير متوقع. حاول مرة أخرى.',
      platformDesc: 'منصتنا تدعم تيذر (USDT) ويو إس دي سي (USDC) وغيرها من العملات الرقمية',
      forgotPassword: 'نسيت كلمة المرور؟',
      validation: {
        nameMin: 'الاسم يجب أن يكون حرفين على الأقل',
        emailInvalid: 'البريد الإلكتروني غير صالح',
        passwordMin: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
        passwordRequired: 'كلمة المرور مطلوبة',
        passwordMismatch: 'كلمتا المرور غير متطابقتين',
      },
    },
    home: {
      badge: 'منصة آمنة ومرخصة',
      heroTitle1: 'اشترِ العملات الرقمية',
      heroTitle2: 'ببطاقتك الائتمانية',
      heroDesc: 'منصة سهلة وآمنة لشراء تيذر (USDT) ويو إس دي سي (USDC) وغيرها من العملات الرقمية. نقبل جميع البطاقات من جميع أنحاء العالم.',
      startNow: 'ابدأ الآن',
      available: 'متاح في 150+ دولة',
      cards: 'Visa, Mastercard, Amex',
      instantOps: 'عمليات فورية',
      livePrices: 'أسعار مباشرة',
      livePricesDesc: 'أسعار محدثة للعملات الرقمية الأكثر شهرة',
      whyUs: 'لماذا تختارنا؟',
      whyUsDesc: 'نوفر لك أفضل تجربة لشراء العملات الرقمية بأمان وسرعة',
      security: 'أمان عالي',
      securityDesc: 'تشفير من الدرجة البنكية وحماية متقدمة لبياناتك وأموالك',
      speed: 'سرعة فائقة',
      speedDesc: 'عمليات شراء فورية تصل خلال دقائق مباشرة إلى محفظتك',
      global: 'تغطية عالمية',
      globalDesc: 'نقبل البطاقات من جميع البلدان ونوفر خدماتنا في أكثر من 150 دولة',
      ctaTitle: 'ابدأ رحلتك في عالم الكريبتو اليوم',
      ctaDesc: 'انضم إلى آلاف المستخدمين الذين يثقون بنا لشراء العملات الرقمية بسهولة وأمان',
      createFreeAccount: 'إنشاء حساب مجاني',
      copyright: '© 2024 CrebtoPay. جميع الحقوق محفوظة.',
    },
    dashboard: {
      availableCryptos: 'العملات المتاحة',
      bestPerformance: 'أفضل أداء اليوم',
      paymentMethods: 'طرق الدفع',
      allCards: 'جميع البطاقات',
      availableCryptosTitle: 'العملات الرقمية المتاحة',
      chooseCrypto: 'اختر العملة التي تريد شراءها',
      lastUpdate: 'آخر تحديث',
      searchPlaceholder: 'ابحث عن عملة...',
      refresh: 'تحديث',
      showMore: 'عرض المزيد',
      remaining: 'عملة متبقية',
      noResults: 'لا توجد عملات مطابقة للبحث',
      buy: 'شراء',
    },
    wallet: {
      totalBalance: 'إجمالي الرصيد',
      deposit: 'إيداع',
      withdraw: 'سحب',
      transfer: 'تحويل',
      receive: 'استقبال',
      send: 'إرسال',
      assets: 'العملات',
      deposits: 'الاستقبال',
      withdrawals: 'الإرسال',
      hideSmall: 'إخفاء الأرصدة الصغيرة',
      noBalances: 'لا توجد أرصدة بعد',
      noBalancesHint: 'عند شراء أو إيداع عملات رقمية، ستظهر أرصدتك هنا',
      noResults: 'لا توجد نتائج',
      noDeposits: 'لا توجد عمليات استقبال',
      noWithdrawals: 'لا توجد عمليات إرسال',
      pending: 'قيد المراجعة',
      approved: 'تمت الموافقة',
      rejected: 'مرفوض',
      depositCrypto: 'استقبال عملة',
      depositWord: 'استقبال',
      withdrawWord: 'إرسال',
      selectCrypto: 'اختر العملة',
      selectNetwork: 'الشبكة',
      networkFee: 'رسوم',
      depositAddress: 'عنوان الاستقبال',
      noAddressSet: 'لم يتم تعيين عنوان لشبكة',
      yet: 'بعد',
      autoDetection: 'الاكتشاف التلقائي مفعّل',
      autoDetectionDesc: 'بعد إرسال العملة إلى العنوان أعلاه، أدخل هاش المعاملة أدناه للتحقق وإضافة الرصيد.',
      networkWarning: 'أرسل فقط',
      networkWarning2: 'عبر شبكة',
      networkWarningEnd: 'الإرسال عبر شبكة مختلفة قد يؤدي لفقدان الأموال.',
      withdrawCrypto: 'إرسال عملة رقمية',
      currency: 'العملة',
      chooseCurrency: 'اختر العملة',
      network: 'الشبكة',
      chooseNetwork: 'اختر الشبكة',
      amount: 'المبلغ',
      all: 'الكل',
      available: 'المتاح',
      walletAddress: 'عنوان المحفظة',
      addressVerified: 'العنوان تم التحقق منه عبر البلوكتشين',
      addressInvalid: 'العنوان غير صالح',
      verifyingAddress: 'جاري التحقق من العنوان...',
      sending: 'جاري الإرسال...',
      requestSent: 'تم إرسال الطلب',
      requestSentDesc: 'سيتم مراجعة طلب الإرسال من قبل الإدارة',
      copied: 'تم النسخ',
      userName: 'الاسم',
      search: 'بحث',
      fee: 'رسوم',
      receiveTime: 'زمن الاستقبال',
      minutes: 'دقائق',
      internalTransfer: 'تحويل داخلي',
      internalTransferDesc: 'أدخل معرّف المستخدم المستلم والكمية',
      recipientId: 'معرّف المستلم (ID)',
      recipientIdHint: 'أدخل معرّف المستخدم المكون من 16 رقم',
      searching: 'جاري البحث...',
      recipient: 'المستلم:',
      idNotFound: 'معرّف غير موجود',
      quantity: 'الكمية',
      selectCurrency: 'اختر العملة',
      transferSuccess: 'تم التحويل بنجاح ✅',
      confirmTransfer: 'تأكيد التحويل',
      transferring: 'جاري التحويل...',
      txHashLabel: 'هاش المعاملة (TX Hash)',
      txHashHint: 'بعد إرسال العملة، أدخل هاش المعاملة هنا للتحقق',
      confirmReceive: 'تأكيد الاستقبال',
      verifying: 'جارٍ التحقق...',
      chooseSendMethod: 'اختر طريقة الإرسال',
      chooseSendMethodDesc: 'حدد نوع التحويل المطلوب',
      internalTransferTitle: 'تحويل داخلي',
      internalTransferHint: 'إرسال لمستخدم آخر عبر معرّف ID',
      externalSend: 'إرسال خارجي',
      externalSendHint: 'إرسال عبر عنوان المحفظة والشبكة',
      externalSendTitle: 'إرسال خارجي',
      externalSendDesc: 'أرسل عملاتك إلى عنوان محفظة خارجي',
      selectCoin: 'اختر العملة',
      selectNetworkLabel: 'الشبكة',
      walletAddressLabel: 'عنوان المحفظة',
      quantityLabel: 'الكمية',
      allBalance: 'الكل',
      availableBalance: 'المتاح',
      confirmSend: 'تأكيد الإرسال',
      sendingExternal: 'جاري الإرسال...',
      swapTitle: 'استبدال العملات',
      swapDesc: 'استبدل عملة بأخرى مع رسوم 0.8% فقط',
      swapFromLabel: 'من عملة',
      swapToLabel: 'إلى عملة',
      swapSelectCoin: 'اختر العملة',
      swapYouGet: 'ستحصل على',
      swapValueUsd: 'القيمة بالدولار',
      swapFee: 'رسوم الاستبدال (0.8%)',
      swapPrice: 'سعر',
      swapConfirm: 'تأكيد الاستبدال',
      swapping: 'جاري الاستبدال...',
      swap: 'استبدال',
      history: 'السجل',
      noHistory: 'لا توجد عمليات سابقة',
      generateAddress: 'إنشاء عنوان',
      generatingAddress: 'جاري الإنشاء...',
      freeTransfer: 'تحويل مجاني — بدون رسوم',
    },
    transactions: {
      title: 'سجل المعاملات',
      subtitle: 'جميع عمليات الشراء السابقة',
      searchPlaceholder: 'بحث عن عملة...',
      noTransactions: 'لا توجد معاملات',
      noSearchResults: 'لم يتم العثور على نتائج للبحث',
      noTransactionsHint: 'لم تقم بأي عمليات شراء بعد. ابدأ بشراء عملتك الرقمية الأولى!',
      buy: 'شراء',
      completed: 'مكتمل',
      pending: 'قيد المعالجة',
      failed: 'فشل',
      fee: 'رسوم',
    },
    purchase: {
      buyTitle: 'شراء',
      amountUsd: 'المبلغ (USD)',
      yourWallet: 'محفظتك لاستلام العملة',
      networkLabel: 'الشبكة',
      chooseNetwork: 'اختر الشبكة',
      fee: 'رسوم',
      time: 'الوقت',
      walletAddressLabel: 'عنوان محفظتك',
      walletAddressPlaceholder: 'أدخل عنوان محفظتك',
      totalAmount: 'المبلغ',
      networkFee: 'رسوم الشبكة',
      total: 'الإجمالي',
      youWillReceive: 'ستستلم',
      nextCard: 'التالي - بيانات البطاقة',
      cardInfo: 'بيانات البطاقة',
      cardNumber: 'رقم البطاقة',
      cardExpiry: 'تاريخ الانتهاء',
      cardCvv: 'CVV',
      cardName: 'اسم حامل البطاقة',
      cardNamePlaceholder: 'الاسم كما على البطاقة',
      backToDetails: 'رجوع',
      nextProof: 'التالي - إثبات الدفع',
      proofTitle: 'إثبات الدفع',
      proofDesc: 'قم بتحويل المبلغ ثم ارفع صورة إثبات الدفع (صورة الشاشة)',
      proofTransferTo: 'حوّل المبلغ التالي:',
      proofUpload: 'ارفع صورة إثبات الدفع',
      proofMaxSize: 'الحد الأقصى: 5MB',
      proofFileTooLarge: 'حجم الملف يتجاوز 5MB',
      proofSubmit: 'إرسال وتحقق',
      proofProcessing: 'جاري المعالجة...',
      proofNoFile: 'يرجى رفع إثبات الدفع أولاً',
      verifying: 'جاري التحقق...',
      verifyingDesc: 'الذكاء الاصطناعي يتحقق من إثبات الدفع',
      approvedTitle: 'تمت الموافقة تلقائياً ✅',
      approvedDesc: 'تحقق الذكاء الاصطناعي من إثبات الدفع ووافق على المعاملة',
      approvedTransfer: 'سيتم تحويل',
      approvedToWallet: 'إلى محفظتك',
      pendingTitle: 'قيد المراجعة',
      pendingDesc: 'يحتاج إثبات الدفع إلى مراجعة يدوية من الإدارة',
      aiWarning: 'بعد إدخال بيانات البطاقة ورفع إثبات الدفع، سيقوم الذكاء الاصطناعي بالتحقق والموافقة تلقائياً.',
      purchaseFailed: 'فشل في إتمام العملية',
      purchaseFailedDesc: 'حدث خطأ. حاول مرة أخرى.',
      minAmount: 'الحد الأدنى للشراء 10 دولار',
      maxAmount: 'الحد الأقصى 10,000,000 دولار',
      invalidWallet: 'عنوان المحفظة غير صالح',
      invalidCardNumber: 'رقم البطاقة غير صالح',
      invalidExpiry: 'صيغة غير صحيحة (MM/YY)',
      invalidCvv: 'CVV غير صالح',
      cardNameRequired: 'اسم حامل البطاقة مطلوب',
    },
    changePassword: {
      title: 'تغيير كلمة المرور',
      button: 'تغيير كلمة المرور',
      current: 'كلمة المرور الحالية',
      new: 'كلمة المرور الجديدة',
      confirm: 'تأكيد كلمة المرور',
      saving: 'جاري الحفظ...',
      saveChanges: 'حفظ التغييرات',
      success: 'تم التغيير بنجاح',
      successDesc: 'تم تغيير كلمة المرور الخاصة بك.',
    },
    forgotPassword: {
      title: 'استعادة كلمة المرور',
      otpTitle: 'إدخال رمز التحقق',
      newPasswordTitle: 'كلمة مرور جديدة',
      emailDesc: 'أدخل بريدك الإلكتروني وسنرسل لك رمز تحقق مكون من 6 أرقام.',
      otpDesc: 'أدخل الرمز المكون من 6 أرقام المرسل إلى بريدك.',
      otpSentTo: 'تم إرسال الرمز إلى',
      otpError: 'يرجى إدخال الرمز المكون من 6 أرقام',
      newPasswordDesc: 'أدخل كلمة المرور الجديدة.',
      sendCode: 'إرسال الرمز',
      sending: 'جاري الإرسال...',
      verify: 'تحقق',
      verifying: 'جاري التحقق...',
      codeSent: 'تم الإرسال',
      codeSentDesc: 'تحقق من بريدك الإلكتروني للحصول على رمز التحقق.',
      codeVerified: 'تم التحقق',
      codeVerifiedDesc: 'يمكنك الآن تعيين كلمة مرور جديدة.',
      invalidCode: 'رمز غير صحيح',
      passwordChanged: 'تم بنجاح',
      passwordChangedDesc: 'تم تغيير كلمة المرور بنجاح.',
      resetButton: 'تعيين كلمة المرور',
    },
    chat: {
      title: 'المساعد الذكي',
      liveSupport: 'الدعم المباشر',
      supportChat: 'محادثة مع فريق الدعم',
      askAboutCrypto: 'اسأل عن العملات الرقمية',
      waiting: 'في الانتظار',
      connected: 'متصل',
      guest: 'زائر',
      welcomeTitle: 'مرحباً! كيف يمكنني مساعدتك؟',
      welcomeDesc: 'يمكنني الإجابة على أسئلتك حول العملات الرقمية، عمليات الشراء والبيع، وتقديم نصائح أمنية للمحافظ الرقمية.',
      suggestion1: 'ما هي البيتكوين؟',
      suggestion2: 'كيف أحمي محفظتي؟',
      suggestion3: 'ما الفرق بين BTC و ETH؟',
      needHuman: 'هل تحتاج مساعدة بشرية؟',
      requestSupport: 'اطلب موظف دعم',
      cancelSupport: 'إلغاء طلب الدعم',
      clearChat: 'مسح المحادثة',
      typing: 'جاري الكتابة...',
      waitingSupport: 'في انتظار رد فريق الدعم...',
      inputPlaceholder: 'اكتب رسالتك هنا...',
      supportPlaceholder: 'اكتب رسالتك لفريق الدعم...',
      chatWithAI: 'تحدث مع المساعد الذكي',
    },
    admin: {
      title: 'لوحة تحكم المسؤول',
      subtitle: 'إدارة ومتابعة جميع المعاملات والأرباح والدعم',
      aiAssistant: 'المساعد الذكي',
      security: 'مراقبة الأمن',
      users: 'المستخدمون',
      transactions: 'المعاملات',
      devices: 'الأجهزة',
      support: 'رسائل الدعم',
      deposits: 'الإيداعات',
      withdrawals: 'السحوبات',
      commission: 'العمولة',
      settings: 'الإعدادات',
      registeredUsers: 'المستخدمون المسجلون',
      guests: 'الزوار',
    },
    common: {
      loading: 'جاري التحميل...',
      error: 'خطأ',
      save: 'حفظ',
      cancel: 'إلغاء',
      confirm: 'تأكيد',
      delete: 'حذف',
      edit: 'تعديل',
      close: 'إغلاق',
      back: 'رجوع',
      next: 'التالي',
      fillAllFields: 'يرجى ملء جميع الحقول',
      invalidAmount: 'المبلغ غير صحيح',
      insufficientBalance: 'الرصيد غير كافي',
    },
    mfa: {
      setupTitle: 'تفعيل المصادقة الثنائية',
      setupDesc: 'امسح رمز QR باستخدام تطبيق المصادقة (Google Authenticator أو Authy)',
      scanQR: 'امسح هذا الرمز بتطبيق المصادقة على هاتفك',
      orEnterManually: 'أو أدخل الرمز يدوياً:',
      enterCode: 'رمز التحقق',
      activate: 'تفعيل المصادقة الثنائية',
      setupSuccess: 'تم التفعيل بنجاح!',
      setupSuccessDesc: 'تم تفعيل المصادقة الثنائية على حسابك',
      enrollError: 'خطأ في التسجيل',
      needRelogin: 'يرجى تسجيل الدخول مرة أخرى لإعداد المصادقة الثنائية',
      verifyTitle: 'التحقق من الهوية',
      verifyDesc: 'أدخل رمز التحقق من تطبيق المصادقة',
      verify: 'تحقق',
      verifyError: 'خطأ في التحقق',
      invalidCode: 'الرمز غير صحيح، حاول مرة أخرى',
      saveSecretWarning: '⚠️ مهم: احفظ هذا الرمز السري في مكان آمن! ستحتاجه إذا غيّرت هاتفك أو أردت إعادة إضافة تطبيق المصادقة. لن يظهر هذا الرمز مرة أخرى بعد التفعيل.',
      resetButton: 'إعادة تعيين 2FA',
      resetTitle: 'إعادة تعيين المصادقة الثنائية',
      resetDesc: 'سيتم حذف المصادقة الحالية وستحتاج لإعداد واحدة جديدة.',
      resetWarning: 'بعد إعادة التعيين، ستحتاج لمسح رمز QR جديد بتطبيق المصادقة. تأكد من أن التطبيق متاح لديك قبل المتابعة.',
      resetSuccess: 'تم إعادة التعيين',
      resetSuccessDesc: 'يرجى إعداد المصادقة الثنائية الجديدة الآن.',
      lostAuthenticator: 'فقدت تطبيق المصادقة؟',
      resetViaEmail: 'إعادة التعيين عبر البريد الإلكتروني',
      resetViaEmailDesc: 'سنرسل رمز تحقق مكون من 6 أرقام إلى بريدك الإلكتروني لإعادة تعيين المصادقة الثنائية.',
      sendResetCode: 'إرسال رمز التحقق',
      sendingCode: 'جاري الإرسال...',
      resetOtpSent: 'تم الإرسال',
      resetOtpSentDesc: 'تحقق من بريدك الإلكتروني للحصول على رمز التحقق.',
      resetOtpFailed: 'فشل في إرسال الرمز',
      codeSentTo: 'تم إرسال الرمز إلى',
      enterResetCode: 'رمز التحقق من البريد',
      verifyAndReset: 'تحقق وأعد التعيين',
      resetOtpInvalid: 'الرمز غير صحيح أو منتهي الصلاحية',
      resendCode: 'إعادة إرسال الرمز',
      scanNewQR: 'امسح رمز QR الجديد بتطبيق المصادقة على هاتفك',
    },
    profile: {
      title: 'الملف الشخصي',
      subtitle: 'إدارة معلوماتك الشخصية وإعدادات الأمان',
      personalInfo: 'المعلومات الشخصية',
      fullName: 'الاسم الكامل',
      fullNamePlaceholder: 'أدخل اسمك الكامل',
      email: 'البريد الإلكتروني',
      dateOfBirth: 'تاريخ الميلاد',
      selectDateOfBirth: 'اختر تاريخ الميلاد',
      saveChanges: 'حفظ التغييرات',
      securitySettings: 'إعدادات الأمان',
      saved: 'تم الحفظ',
      profileUpdated: 'تم تحديث الملف الشخصي بنجاح',
      uploaded: 'تم الرفع',
      avatarUpdated: 'تم تحديث الصورة الشخصية بنجاح',
      imageOnly: 'يرجى اختيار صورة فقط',
      imageTooLarge: 'حجم الصورة يجب أن يكون أقل من 2 ميغابايت',
    },
  },
};

export default ar;
